export default __webpack_public_path__ + "static/media/STAY_TUNED_FOR_THE_BIG_REVEAL_.57e5b199.svg";